import { render, staticRenderFns } from "./RecoveEmail.vue?vue&type=template&id=7a73ac8f&scoped=true"
import script from "./RecoveEmail.vue?vue&type=script&lang=js"
export * from "./RecoveEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a73ac8f",
  null
  
)

export default component.exports